import { CaseAdmin, Clinic, Lab } from "pwapi";

import { LabList } from "custom-models/frontLoader";

import { useAppSelector } from "store/hooks";

export const useAllowsExternalAccession = ({
  clinic,
  grossed_by_external_lab_id,
  accessioning_lab,
  case_type,
  remains_digital_pc,
  bill_tc,
  bill_pc,
}: {
  clinic?: Clinic;
  grossed_by_external_lab_id?: number;
  accessioning_lab?: Lab | LabList;
  case_type?: CaseAdmin.type;
  remains_digital_pc?: boolean;
  bill_tc?: boolean;
  bill_pc?: boolean;
}) => {
  const externalLab = useAppSelector(({ externalLabs }) =>
    externalLabs && externalLabs[grossed_by_external_lab_id || -1]
      ? externalLabs[grossed_by_external_lab_id || -1]
      : undefined
  );

  return (
    clinic?.name?.includes("Utah Valley Dermatology") ||
    clinic?.name?.includes("Bernhardt") ||
    (clinic?.name?.includes("Rocky Mountain Dermatology") &&
      case_type === CaseAdmin.type.TC_PC) ||
    (clinic?.name?.includes("Grosse Pointe Dermatology Associates") &&
      bill_tc === true &&
      bill_pc === false) ||
    externalLab?.name?.includes("Seacoast") ||
    externalLab?.name?.includes("Sutton Dermatology") ||
    externalLab?.name?.includes("Skin Care Doctors") ||
    externalLab?.name?.includes("Bernhardt") ||
    externalLab?.name?.includes("Dermatology Associates") ||
    externalLab?.name?.includes("Paducah Dermatology") ||
    externalLab?.name?.includes("Integrated Dermatology") ||
    externalLab?.name?.includes("US Path Labs") ||
    externalLab?.name?.includes("Wolverine Dermatology") ||
    externalLab?.name?.includes("Dermatology Associates of West Michigan") ||
    externalLab?.name?.includes("Biotech Clinical Laboratories, Inc") ||
    externalLab?.name?.includes("Jefferson City Medical Group Laboratory") ||
    externalLab?.name?.includes("Dermatology & Skin Cancer Surgery Center") ||
    externalLab?.name?.includes(
      "Advanced Dermatology and Skin Cancer Center PA"
    ) ||
    case_type === CaseAdmin.type.HISTORICAL ||
    accessioning_lab?.settings?.digital_pc?.active ||
    remains_digital_pc
  );
};
